<template>
  <el-dialog :visible.sync="dialogVisible" :title="title" custom-class="custom-dialog" :close-on-click-modal="false"
    @opened="dialogOpen" @closed="dialogClose" width="850px">

        <div style="height:50px; margin:5px 16px 0 0px;">
            <div style="display: inline-block; height:40px;float: right;margin-left:10px;">
                <el-button type="primary" @click="uploadFile()" v-if="isShow">上传应用</el-button>
            </div>
            <div style="display: inline-block; height:40px;float: right;margin-left:10px;">
                <el-button type="primary" @click="getData()">刷新</el-button>
            </div>
        </div>

        <el-table :data="data" style="width: 100%;margin-bottom: 20px;" v-loading="loading"
            :element-loading-text="loadingText" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 255,255,0.7)" row-key="id" border default-expand-all>

            <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
            <el-table-column prop="fileName" label="文件名称" :show-overflow-tooltip="true" width="265"></el-table-column>
            <el-table-column label="文件类型" prop="fileType" show-overflow-tooltip width="70">
                <template slot-scope="scope">
                    <div v-if="scope.row.fileType == 0">全量</div>
                    <div v-if="scope.row.fileType == 1">补丁</div>
                </template>
            </el-table-column>
            <el-table-column label="操作系统" prop="applyScene" show-overflow-tooltip width="200">
                <template slot-scope="scope">
                    <div v-if="scope.row.applyScene == 0">通用</div>
                    <div v-if="scope.row.applyScene == 1">Windwos7/Windows10/Windows11</div>
                    <div v-if="scope.row.applyScene == 2">Linux/Uos/Kylin</div>
                </template>
            </el-table-column>
            <el-table-column label="文件大小（字节）" prop="fileSize" show-overflow-tooltip width="120px;"></el-table-column>
            <el-table-column label="文件MD5" prop="fileMd5" show-overflow-tooltip width="100px;"></el-table-column>
            <el-table-column label="是否同步云服务" prop="" show-overflow-tooltip width="110px;">
                <template slot-scope="scope">
                    <div v-if="scope.row.status == 1">未同步</div>
                    <div v-else-if="scope.row.status == 2">已同步</div>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="80">
                <template slot-scope="scope"> 
                    <el-button v-if="scope.row.status == 2" style="margin-top:5px;" type="text">
                        <a :href="scope.row.fileUrl" target="_blank">下载</a>
                    </el-button>
                    <el-button @click.native.prevent="del(scope.row.id)" style="margin-top:5px;" v-if="isShow" type="text">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
         <!-- 上传应用-->
        <upload-file v-model="upLoadFileVisible" :applyId="applyId" @submit="getData"/>
  </el-dialog>
</template>

<script>
import http from '../../../../../common/http'
import uploadFile from "./uploadFile.vue";

export default {
  name: '',
  components: { uploadFile },
  props: {
    value: Boolean,
    applyId: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loading:false,
      loadingText:"",
      dialogVisible: false,
      upLoadFileVisible: false,
      data: [],
      form: {
        id:""
      },
      title:""
    }
  },
  watch: {
    value(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('input', val)
    },
  },
  created: function () {
  },
  methods: {
    indexMethod(index) {
        return index + 1
    },
    dialogOpen() {
      if(this.isShow){
        this.title = '应用设置'
      }else{
        this.title = '下载'
      }
      this.getData()
    },
    getData() {
        this.loading=true
        this.loadingText="数据加载中..."

        let url = this.thirdApplyFileListUrl
        let data = {
            applyId: this.applyId,
        };
        console.log(JSON.stringify(data))
        // return;
        this.apiPost(url, data).then((res) => {
            if (res.status == 200) {
                this.data = res.data
            } else {
                this.$commonFn.showTip(res.message, 3)
            }
            this.loading=false
        }, (err) => {
            this.loading=false
        });
    },
    uploadFile(){
      this.upLoadFileVisible = true
    },
    //删除
    del(id){
        this.form.id =id;
        this.$commonFn.showConfirm(this.delSuccess);
    },
    delSuccess(){
        let url = this.thirdApplyFileDeleteApplyFileUrl;
        let data = {
            id:this.form.id
        };
        this.apiPost(url,data).then((res)=>{
            if(res.status == 200){
                this.$commonFn.showTip(res.message,1);
                this.getData();
            }else{
                this.$commonFn.showTip(res.message,3);
            }
        },(err)=>{
            console.log(err);
        })
    },
    dialogClose() {
      this.dialogVisible = false
    }
  },
  mixins: [http]
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/apply/thirdApply/components/applySet.vue